import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'angular2-notifications';
import { DialogModalComponent } from '../../../../shared/dialog-modal/dialog-modal.component';
import { ApiService } from '../../../../utils/services/api.service';

@Component({
  selector: 'app-bank-bin-number-info-modal',
  templateUrl: './bank-bin-number-info-modal.component.html',
  styleUrls: ['./bank-bin-number-info-modal.component.scss']
})
export class BankBinNumberInfoModalComponent implements OnInit {

  public banks = [
    "ISBANKASI",
    "VAKIFBANK",
    "YAPIKREDI",
  ];
  public form: FormGroup;
  public showErrors = false;
  public selectedEntity = new BinNumber();

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private notifications: NotificationsService,
    private activeModal: NgbActiveModal) {
  }

  ngOnInit() {


    this.form = new FormGroup({
      "bank": new FormControl(this.selectedEntity.bank, Validators.required),
      "binNumber": new FormControl(this.selectedEntity.binNumber, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });

  }


  onDeleteClicked() {
    let dialogRef = this.modalService.open(DialogModalComponent, { size: 'sm' });
    dialogRef.componentInstance.modalTitle = "Bu kaydı silmek istediğinize emin misiniz?"
    dialogRef.result.then(res => {
      if (res) {
        if (res.type == 'YES') {
          this.apiService.deleteBinNumber(this.selectedEntity.id).subscribe(res => {
            this.notifications.success("Silme işlemi başarılı!");
            this.activeModal.close("DELETE");
          }, error => {
            this.notifications.error("Hata", "İşlem başarısız!");
          })
        }
      }
    });
  }

  onSaveClicked() {
    if (this.form.valid) {
      this.showErrors = false;

      let data = {
        bin_number: this.form.value.binNumber,
        bank: this.form.value.bank
      }

      if (this.selectedEntity.id) {
        this.apiService.updateBinNumber(data, this.selectedEntity.id).subscribe(res => {
          this.notifications.success("Güncelleme işlemi başarılı!");
          this.activeModal.close("SAVE");
        }, error => {
          this.notifications.error("Hata", "İşlem başarısız!");
        });
      } else {
        this.apiService.createBinNumber(data).subscribe(res => {
          this.notifications.success("Kaydetme işlemi başarılı!");
          this.activeModal.close("SAVE");
        }, error => {
          this.notifications.error("Hata", "İşlem başarısız!");
        });
      }

    }
  }

  onCloseClicked() {
    this.activeModal.close();
  }

}
export class BinNumber {
  id:number;
  binNumber:string;
  bank:string;
}


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/bank-bin-numbers/bank-bin-number-info-modal/bank-bin-number-info-modal.component.ts